import type { SpacingType } from './Spacing';

export const getSpacing = (type: SpacingType, size: string | number) => {
  switch (type) {
    case 'm':
      return {
        margin: size,
      };
    case 'p':
      return {
        padding: size,
      };
    case 'mx':
      return {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: size,
        marginRight: size,
      };
    case 'my':
      return {
        marginTop: size,
        marginBottom: size,
        marginLeft: 0,
        marginRight: 0,
      };
    case 'mt':
      return {
        marginTop: size,
      };
    case 'mb':
      return {
        marginBottom: size,
      };
    case 'ml':
      return {
        marginLeft: size,
      };
    case 'mr':
      return {
        marginRight: size,
      };
    case 'px':
      return {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: size,
        paddingRight: size,
      };
    case 'py':
      return {
        paddingTop: size,
        paddingBottom: size,
        paddingLeft: 0,
        paddingRight: 0,
      };
    case 'pt':
      return {
        paddingTop: size,
      };
    case 'pb':
      return {
        paddingBottom: size,
      };
    case 'pl':
      return {
        paddingLeft: size,
      };
    case 'pr':
      return {
        paddingRight: size,
      };
    default:
      return {};
  }
};
